import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Adjunto from "./Adjunto";
import Galeria from "./Galeria";
import ListaAdjuntos from "./ListaAdjuntos";
import ReportePDF from "./ReportePDF";

class F9s extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      ejercicio_fiscal: "",
      no_de_expediente: "",
      auditoria: "INTERNA",
      tipo_de_auditoria: "FINANCIERA",
      unidad_administrativa_auditada_o_programa_auditado: "",
      ente_revisor: "",
      estado_de_la_auditoria: "EN PROCESO",
      observaciones_determinadas: "",
      observaciones_solventadas: "",
      observaciones_por_solventar: "",
      observaciones_remitidas_a_investigacion_administrativa: "",
      observaciones: "",
      usuario_id: "",
      ambito_id: "",

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      f9s: [], // Listado de elementos para la tabla
      loading: false,
      noEdit: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
  }
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  noEditFnc = async () => {
    let noEdit = false
    let busca = this.props.location.pathname.split("/")
    busca.shift()
    let misAmbitos = localStorage.ambitos.split(",")

    if (busca[2]) {
      let res = null
      res = await axios({
        method: "get",
        url:
          "http://143.198.191.211/api/Ambito/" +
          busca[2] +
          "?api_token=" +
          localStorage.api_token,
        data: {},
      })

      let data = res.data
      if (data.fecha_finalizado != null) {
        noEdit = true
      } else {
        if (misAmbitos.includes(busca[2])) {
          noEdit = false
        } else {
          noEdit = true
        }
      }

      if (localStorage.permisos.includes("admin")) {
        noEdit = false
      }
    }
    if (noEdit) {
      this.setState({ noEdit: true })
    } else {
      this.setState({ noEdit: false })
    }
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/F9/ambito/" +
        this.props.match.params.ambito_id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ f9s: res.data, loading: false });
    }).finally(() => {
      this.noEditFnc();
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        this.props.match.params.ambito_id +
        "/9/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      ejercicio_fiscal: "",
      no_de_expediente: "",
      auditoria: "INTERNA",
      tipo_de_auditoria: "FINANCIERA",
      unidad_administrativa_auditada_o_programa_auditado: "",
      ente_revisor: "",
      estado_de_la_auditoria: "EN PROCESO",
      observaciones_determinadas: "",
      observaciones_solventadas: "",
      observaciones_por_solventar: "",
      observaciones_remitidas_a_investigacion_administrativa: "",
      observaciones: "",
      usuario_id: "",
      ambito_id: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      ejercicio_fiscal: row.ejercicio_fiscal,
      no_de_expediente: row.no_de_expediente,
      auditoria: row.auditoria,
      tipo_de_auditoria: row.tipo_de_auditoria,
      unidad_administrativa_auditada_o_programa_auditado: row.unidad_administrativa_auditada_o_programa_auditado,
      ente_revisor: row.ente_revisor,
      estado_de_la_auditoria: row.estado_de_la_auditoria,
      observaciones_determinadas: row.observaciones_determinadas,
      observaciones_solventadas: row.observaciones_solventadas,
      observaciones_por_solventar: row.observaciones_por_solventar,
      observaciones_remitidas_a_investigacion_administrativa: row.observaciones_remitidas_a_investigacion_administrativa,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      ejercicio_fiscal: row.ejercicio_fiscal,
      no_de_expediente: row.no_de_expediente,
      auditoria: row.auditoria,
      tipo_de_auditoria: row.tipo_de_auditoria,
      unidad_administrativa_auditada_o_programa_auditado: row.unidad_administrativa_auditada_o_programa_auditado,
      ente_revisor: row.ente_revisor,
      estado_de_la_auditoria: row.estado_de_la_auditoria,
      observaciones_determinadas: row.observaciones_determinadas,
      observaciones_solventadas: row.observaciones_solventadas,
      observaciones_por_solventar: row.observaciones_por_solventar,
      observaciones_remitidas_a_investigacion_administrativa: row.observaciones_remitidas_a_investigacion_administrativa,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id,
      ejercicio_fiscal: row.ejercicio_fiscal,
      no_de_expediente: row.no_de_expediente,
      auditoria: row.auditoria,
      tipo_de_auditoria: row.tipo_de_auditoria,
      unidad_administrativa_auditada_o_programa_auditado: row.unidad_administrativa_auditada_o_programa_auditado,
      ente_revisor: row.ente_revisor,
      estado_de_la_auditoria: row.estado_de_la_auditoria,
      observaciones_determinadas: row.observaciones_determinadas,
      observaciones_solventadas: row.observaciones_solventadas,
      observaciones_por_solventar: row.observaciones_por_solventar,
      observaciones_remitidas_a_investigacion_administrativa: row.observaciones_remitidas_a_investigacion_administrativa,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      ejercicio_fiscal: this.state.ejercicio_fiscal,
      no_de_expediente: this.state.no_de_expediente,
      auditoria: this.state.auditoria,
      tipo_de_auditoria: this.state.tipo_de_auditoria,
      unidad_administrativa_auditada_o_programa_auditado: this.state.unidad_administrativa_auditada_o_programa_auditado,
      ente_revisor: this.state.ente_revisor,
      estado_de_la_auditoria: this.state.estado_de_la_auditoria,
      observaciones_determinadas: this.state.observaciones_determinadas,
      observaciones_solventadas: this.state.observaciones_solventadas,
      observaciones_por_solventar: this.state.observaciones_por_solventar,
      observaciones_remitidas_a_investigacion_administrativa: this.state.observaciones_remitidas_a_investigacion_administrativa,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios.post("http://143.198.191.211/api/F9", data, config).then((res) => {
      this.closeModal();
      toast.success(res.data.text, { autoClose: 1000 });
      this.cargaTabla();
      this.setState({ loading: false });
    });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      ejercicio_fiscal: this.state.ejercicio_fiscal,
      no_de_expediente: this.state.no_de_expediente,
      auditoria: this.state.auditoria,
      tipo_de_auditoria: this.state.tipo_de_auditoria,
      unidad_administrativa_auditada_o_programa_auditado: this.state.unidad_administrativa_auditada_o_programa_auditado,
      ente_revisor: this.state.ente_revisor,
      estado_de_la_auditoria: this.state.estado_de_la_auditoria,
      observaciones_determinadas: this.state.observaciones_determinadas,
      observaciones_solventadas: this.state.observaciones_solventadas,
      observaciones_por_solventar: this.state.observaciones_por_solventar,
      observaciones_remitidas_a_investigacion_administrativa: this.state.observaciones_remitidas_a_investigacion_administrativa,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put("http://143.198.191.211/api/F9/" + this.state.id, data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/F9/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeEjercicioFiscal = e => {
    this.setState({ ejercicio_fiscal: e.target.value });
  };

  onChangeNoDeExpediente = e => {
    this.setState({ no_de_expediente: e.target.value });
  };

  onChangeAuditoria = e => {
    this.setState({ auditoria: e.target.value });
  };

  onChangeTipoDeAuditoria = e => {
    this.setState({ tipo_de_auditoria: e.target.value });
  };

  onChangeUnidadAdministrativaAuditadaOProgramaAuditado = e => {
    this.setState({ unidad_administrativa_auditada_o_programa_auditado: e.target.value });
  };

  onChangeEnteRevisor = e => {
    this.setState({ ente_revisor: e.target.value });
  };

  onChangeEstadoDeLaAuditoria = e => {
    this.setState({ estado_de_la_auditoria: e.target.value });
  };

  onChangeObservacionesDeterminadas = e => {
    this.setState({ observaciones_determinadas: e.target.value });
  };

  onChangeObservacionesSolventadas = e => {
    this.setState({ observaciones_solventadas: e.target.value });
  };

  onChangeObservacionesPorSolventar = e => {
    this.setState({ observaciones_por_solventar: e.target.value });
  };

  onChangeObservacionesRemitidasAInvestigacionAdministrativa = e => {
    this.setState({ observaciones_remitidas_a_investigacion_administrativa: e.target.value });
  };

  onChangeObservaciones = e => {
    this.setState({ observaciones: e.target.value });
  };

  onChangeUsuarioId = e => {
    this.setState({ usuario_id: e.target.value });
  };

  onChangeAmbitoId = e => {
    this.setState({ ambito_id: e.target.value });
  };



  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row, idx, noEdit) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <Adjunto
            ambito_id={this.props.match.params.ambito_id}
            formato={"9"}
            id={row.id}
            disabled={noEdit}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm btn-elimina"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled={noEdit}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  render() {
    const columns = [
      {
        dataField: "ejercicio_fiscal",
        text: "Ejercicio Fiscal",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "no_de_expediente",
        text: "No De Expediente",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "auditoria",
        text: "Auditoria",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "tipo_de_auditoria",
        text: "Tipo De Auditoria",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "unidad_administrativa_auditada_o_programa_auditado",
        text: "Unidad Administrativa Auditada O Programa Auditado",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "ente_revisor",
        text: "Ente Revisor",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "estado_de_la_auditoria",
        text: "Estado De La Auditoria",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones_determinadas",
        text: "Observaciones Determinadas",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones_solventadas",
        text: "Observaciones Solventadas",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones_por_solventar",
        text: "Observaciones Por Solventar",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones_remitidas_a_investigacion_administrativa",
        text: "Observaciones Remitidas A Investigacion Administrativa",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones",
        text: "Observaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },

      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        formatExtraData: this.state.noEdit,
        headerStyle: () => {
          return {
            width: "140px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">RELACION DE AUDITORÍAS PRACTICADAS POR EL OIC</h3>
              <br />
              <small className="text-muted">
                Gestione la información del anexo numero 9 referente
                a relacion de auditorías practicadas por el oic, para el ámbito {this.props.match.params.ambito_id}
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.f9s}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <button
                              className="btn btn-primary btn-nuevo"
                              onClick={this.ModalNuevo}
                              data-tip="Nuevo"
                              disabled={this.state.noEdit}
                            >
                              <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                          </ButtonGroup>
                          <ButtonGroup
                            className="mr-2"
                            aria-label="Second group"
                          >
                            <ReportePDF ambito_id={this.props.match.params.ambito_id}
                              anexo="9" />
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga Excel"
                              target="_blank"
                              href={
                                "http://143.198.191.211/xlsx/?a=" +
                                this.props.match.params.ambito_id +
                                "&f=9"
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Descargar
                              Excel
                            </a>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Ejercicio Fiscal:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="ejercicio_fiscal"
                  value={this.state.ejercicio_fiscal}
                  onChange={this.onChangeEjercicioFiscal}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  No De Expediente:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="no_de_expediente"
                  value={this.state.no_de_expediente}
                  onChange={this.onChangeNoDeExpediente}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Auditoria:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  as="select"
                  custom
                  type="text"
                  name="auditoria"
                  value={this.state.auditoria}
                  onChange={this.onChangeAuditoria}
                >
                  <option>INTERNA</option>
                  <option>EXTERNA</option>
                </Form.Control>
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Tipo De Auditoria:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  as="select"
                  custom
                  type="text"
                  name="tipo_de_auditoria"
                  value={this.state.tipo_de_auditoria}
                  onChange={this.onChangeTipoDeAuditoria}
                >
                  <option>FINANCIERA</option>
                  <option>OBRA PÚBLICA</option>
                  <option>DESEMPEÑO</option>
                  <option>RECURSOS MATERIALES</option>
                  <option>RECURSOS HUMANOS</option>
                  <option>INMUEBLES</option>
                </Form.Control>
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Unidad Administrativa Auditada O Programa Auditado:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="unidad_administrativa_auditada_o_programa_auditado"
                  value={this.state.unidad_administrativa_auditada_o_programa_auditado}
                  onChange={this.onChangeUnidadAdministrativaAuditadaOProgramaAuditado}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Ente Revisor:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="ente_revisor"
                  value={this.state.ente_revisor}
                  onChange={this.onChangeEnteRevisor}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Estado De La Auditoria:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  as="select"
                  custom
                  type="text"
                  name="estado_de_la_auditoria"
                  value={this.state.estado_de_la_auditoria}
                  onChange={this.onChangeEstadoDeLaAuditoria}
                >
                  <option>EN PROCESO</option>
                  <option>CONCLUIDA</option>
                </Form.Control>
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Observaciones Determinadas:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones_determinadas"
                  value={this.state.observaciones_determinadas}
                  onChange={this.onChangeObservacionesDeterminadas}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Observaciones Solventadas:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones_solventadas"
                  value={this.state.observaciones_solventadas}
                  onChange={this.onChangeObservacionesSolventadas}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Observaciones Por Solventar:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones_por_solventar"
                  value={this.state.observaciones_por_solventar}
                  onChange={this.onChangeObservacionesPorSolventar}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Observaciones Remitidas A Investigacion Administrativa:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones_remitidas_a_investigacion_administrativa"
                  value={this.state.observaciones_remitidas_a_investigacion_administrativa}
                  onChange={this.onChangeObservacionesRemitidasAInvestigacionAdministrativa}
                />
              </Col>
              <Col xs="12" md="12" lg="12">
                <Form.Label>
                  Observaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones"
                  value={this.state.observaciones}
                  onChange={this.onChangeObservaciones}
                />
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.ejecutar} className="btn-ejecutar" disabled={this.state.noEdit} >
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.ejecutar} disabled={this.state.noEdit}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12} md={8}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Ejercicio Fiscal:
                    </Col>
                    <Col xs={10}>{this.state.ejercicio_fiscal}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      No De Expediente:
                    </Col>
                    <Col xs={10}>{this.state.no_de_expediente}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Auditoria:
                    </Col>
                    <Col xs={10}>{this.state.auditoria}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Tipo De Auditoria:
                    </Col>
                    <Col xs={10}>{this.state.tipo_de_auditoria}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Unidad Administrativa Auditada O Programa Auditado:
                    </Col>
                    <Col xs={10}>{this.state.unidad_administrativa_auditada_o_programa_auditado}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Ente Revisor:
                    </Col>
                    <Col xs={10}>{this.state.ente_revisor}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Estado De La Auditoria:
                    </Col>
                    <Col xs={10}>{this.state.estado_de_la_auditoria}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones Determinadas:
                    </Col>
                    <Col xs={10}>{this.state.observaciones_determinadas}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones Solventadas:
                    </Col>
                    <Col xs={10}>{this.state.observaciones_solventadas}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones Por Solventar:
                    </Col>
                    <Col xs={10}>{this.state.observaciones_por_solventar}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones Remitidas A Investigacion Administrativa:
                    </Col>
                    <Col xs={10}>{this.state.observaciones_remitidas_a_investigacion_administrativa}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones:
                    </Col>
                    <Col xs={10}>{this.state.observaciones}</Col>
                  </Row>

                </Col>
                <Col xs={12} md={4}>
                  <Row>
                    <Col xs={12}>
                      <h5>Archivos Adjuntos</h5>
                    </Col>
                    <Col xs={12}>
                      <ListaAdjuntos archivos={this.state.frm_lista_documentos} cargaDocumentos={this.cargaDocumentos} rowId={this.state.id} />
                    </Col>
                    <Col xs={12}>
                      <Galeria imagenes={this.state.frm_lista_documentos} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <ReactTooltip />
      </Layout >
    );
  }
}

export default F9s;
